import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

import { ReactComponent as ArrowDownSVG } from "assets/img/ArrowDown.svg";

import Pagination from "components/Pagination/Pagination";

const Content = styled.div`
  min-width: 100%;
  max-width: 100%;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  width: 100%;
  height: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      height: 100%;
      opacity: 1;
      transform: scaleY(1);
      margin-bottom: 33px;
      padding: 24px;

      @media (max-width: ${breakpoints.mobileL}) {
        padding: 24px 16px;
      }
    `}
`;
const SectionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  border: 1px solid #a5aaaf;
  box-sizing: border-box;
  padding: 8px 15px 8px 20px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
  text-align: left;
  color: #03589c;
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      margin-bottom: 24px;
    `}

  @media (max-width: ${breakpoints.mobileL}) {
    line-height: 24px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const DataRow = styled.div`
  display: flex;
  min-width: 100%;
  padding: 16px 0;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
const Label = styled.div`
  min-width: 50%;
  width: 50%;
  padding-right: 20px;
  font-weight: normal;
  font-size: 12px;
  text-transform: uppercase;
  color: #7b848d;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    padding-right: 0;
  }
`;
const Data = styled(Label)`
  font-weight: bold;
  text-transform: none;
  word-break: break-all;

  @media (max-width: ${breakpoints.mobileL}) {
    align-items: center;
  }
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function TableRow(props) {
  return (
    <Row>
      <DataRow>
        <Label>NUMBER</Label>
        <Data>{props.trademarkNumber || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>TYPE</Label>
        <Data>{props.type || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>FILLING DATE</Label>
        <Data>{props.fillingDate || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>REGISTRATION DATE</Label>
        <Data>{props.registrationDate || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>NICE CLASSIFICATION</Label>
        <Data>{props.niceClassification || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>STATUS</Label>
        <Data>{props.trademarkStatus || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>BASIS</Label>
        <Data>{props.basis || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>REFERENCE</Label>
        <Data>{props.reference || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>OWNER ID</Label>
        <Data>{props.ownerIdNumber || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>OWNER NAME</Label>
        <Data>{props.ownerName || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>REPRESENTATIVE ID</Label>
        <Data>{props.representativeIdNumber || "—"}</Data>
      </DataRow>

      <DataRow>
        <Label>REPRESENTATIVE NAME</Label>
        <Data>{props.representativeName || "—"}</Data>
      </DataRow>
    </Row>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  trademarkNumber: PropTypes.string,
  type: PropTypes.string,
  fillingDate: PropTypes.string,
  registrationDate: PropTypes.string,
  niceClassification: PropTypes.string,
  trademarkStatus: PropTypes.string,
  basis: PropTypes.string,
  reference: PropTypes.string,
  ownerIdNumber: PropTypes.string,
  ownerName: PropTypes.string,
  representativeIdNumber: PropTypes.string,
  representativeName: PropTypes.string,
};

function GlobalSearchResultsDesktop({ globalSearchResults }) {
  const [isOpen, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = globalSearchResults?.length || 0;

  if (!globalSearchResults) return null;

  return (
    <>
      <SectionButton id="global-search-results" isOpen={isOpen} onClick={() => setOpen(!isOpen)}>
        Global Search Results
        <ArrowDownSVG fill="#F37217" transform={isOpen ? "rotate(180)" : undefined} />
      </SectionButton>

      <Content isOpen={isOpen}>
        {globalSearchResults.length ? (
          <>
            <Pagination top currentPage={currentPage} totalPages={totalPages} onClick={setCurrentPage} />
            <TableRow {...globalSearchResults[currentPage - 1]} />
          </>
        ) : (
          <EmptyMessage>No conflicting Global search results found</EmptyMessage>
        )}
      </Content>
    </>
  );
}

GlobalSearchResultsDesktop.propTypes = {
  globalSearchResults: PropTypes.arrayOf(PropTypes.object),
};

export default GlobalSearchResultsDesktop;
